// extracted by mini-css-extract-plugin
export var readonly = "_hw-1";
export var star = "_hw-0";